import styled from "styled-components";
import { ON_TOP_BELOW_COOKIE_BANNER } from "constants/z-index";
export const StyledStickySignupButton = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${ON_TOP_BELOW_COOKIE_BANNER};
  background-color: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  padding: 16px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  transform: translateY(${({ isVisible })=>isVisible ? "0" : "100%"});
  transition: ${({ mounted })=>mounted ? "transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)" : "none"};
  will-change: transform;
`;
